import {getData, postData} from './redux_data';
import {
    GET_SEGMENTACION,
    MODIFY_SEGMENTACION,
    ADD_SEGMENTACION,
    DELETE_SEGMENTACION,
    UPDATE_SEGMENTACION,
} from '../constants/action_types';

export function getSegmentacionList(centroId) {
    return getData('DCSegmentacions?centro_id='+centroId, GET_SEGMENTACION, centroId);
}

export function modifySegmentacion(segmentacion) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_SEGMENTACION, payload: segmentacion });
    }
}

export function addSegmentacion(segmentacion) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_SEGMENTACION, payload: segmentacion });
    }
}

export function removeSegmentacion(segmentacion) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_SEGMENTACION, payload: segmentacion });
    }
}

export function updateSegmentacionListDB (segmentacionList, centro_id) {
    return postData('DCSegmentacions/lista?centro_id=' + centro_id, UPDATE_SEGMENTACION, segmentacionList, 'Segmentaciones del centro actualizadas', undefined);
}

